import { render, staticRenderFns } from "./FeedbackEditorReview.vue?vue&type=template&id=380bd372&scoped=true&"
import script from "./FeedbackEditorReview.vue?vue&type=script&lang=ts&"
export * from "./FeedbackEditorReview.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackEditorReview.vue?vue&type=style&index=0&id=380bd372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380bd372",
  null
  
)

export default component.exports